import { render, staticRenderFns } from "./share.vue?vue&type=template&id=12154418&scoped=true"
import script from "./share.vue?vue&type=script&lang=ts"
export * from "./share.vue?vue&type=script&lang=ts"
import style0 from "./share.vue?vue&type=style&index=0&id=12154418&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12154418",
  null
  
)

export default component.exports